const ApiErrorCode = {
  0: "Success",
  1: "Server error",
  2: "Token expired",
  3: "Invalid token",
  4: "Record not exist",
  5: "Bad request",
  6: "Record already exist",
  7: "Status not exist",
  8: "Invalid request",

  1001: "Email required",
  1002: "Id not exist",
  1003: "Email not exist",
  1004: "Email already exist",
  1005: "Fcm token required",
  1006: "Platform required",
  1007: "Devicename required",
  1008: "Latitude required",
  1009: "Longitude required",
  1010: "Timezone required",
  1011: "Refreshtoken required",
  1012: "Image required",
  1013: "Reason required",
  1014: "Name required",
  1015: "Otp type required",
  1016: "Otp required",
  1017: "Otp verifyid required",
  1018: "Password is invalid",
  1019: "Account is blocked",
  1020: "Account is deleted",
  1021: "Password is required",
  1022: "Login attempt limit reached",
  1023: "Invalid input format",
  1024: "Invalid type",
  1025: "Phone number required",
  1026: "Country code required",
  1027: "Wrong OTP",
  1028: "OTP expired",
  1029: "Account not found",
  1030: "Account already exist",
  1031: "Current password incorrect",
  1032: "Invalid image",
  1033: "Current password required",
  1034: "Status required",

  2001: "User is temporary blocked for OTP",
  2002: "Tags array required",
  2003: "Allow message flag required(true or false)",
  2004: "Show bio flag required",
  2005: "Show website flag required",
  2006: "Show email flag required",
  2007: "Refere connection flag required",
  2008: "Job title required",
  2009: "Comapny name required",
  2010: "Website name required",
  2011: "Bio required",

  3001: "Title is required",
  3002: "Content required",
  3003: "Type required",
  3004: "Country name required",
  3005: "Country code required",
  3006: "Is active flag required",
  3007: "Is default flag required",
  3008: "Note required",
  3009: "Tag already exists",
};

export const getApiMessage = (code) => {
  return ApiErrorCode[code] || "Something went wrong";
};
